export default "__VITE_ASSET__BWnAZV9B__"